import React from 'react'
import PropTypes from 'prop-types'
import SvgIcon from '../../svgIcon'
import styles from './squareButton.css'

const SquareButton = (props) => {
  const { icon, label, format } = props
  const iconComponent = (!icon) ? null : <SvgIcon icon={icon} className={styles.icon}/>
  const formatStyles = (Array.isArray(format)) ? format.map((item) => styles[item]) : [ styles[format] ]
  const buttonStyles = [styles.button, ...formatStyles]
  return (
    <button className={buttonStyles.join(' ')} {...props}>
      {iconComponent}
      <span className={styles.label}>{label}</span>
    </button>
  )
}

SquareButton.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  format: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string
  ])
}

SquareButton.defaultProps = {
  format: 'default'
}

export default SquareButton



// WEBPACK FOOTER //
// ./src/components/buttons/squareButton/squareButton.jsx